// Conditional-visibility evaluator shared (by copy) with the P2 embed renderer.
// Pure and DOM-free; single-level semantics — a showIf is evaluated against the
// raw submitted values, never against the referenced field's own visibility.

export function evaluateShowIf(showIf, values) {
  if (!showIf || !showIf.field) return true
  const v = values ? values[showIf.field] : undefined
  return Array.isArray(showIf.in) && showIf.in.includes(v)
}

export function visibleFields(fields, values) {
  return (fields || []).filter((f) => evaluateShowIf(f.showIf, values))
}
